import Hero from "./components/Hero";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Stats from "./components/Stats";
import WhyChooseUs from "./components/WhyChooseUs";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import DnsNetworkLayout from "./components/DnsNetworkLayout";
import WorldMap from "./components/WorldMap";
import PublicDNSList from "./components/PublicDNSList";

function App() {
  return (
    <>
      <Hero />
      <Features />
      <DnsNetworkLayout />
      <Stats />
      <WorldMap />
      <WhyChooseUs />
      <PublicDNSList />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
}

export default App;